import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { GetQuestionsBySubject } from '../services/apiservice';
import InterviewQuestionItem from '../Components/InterviewQuestionItem';
import Loader from '../Components/Loader';

const InterviewQuestionsAnswers = () => {
  const { subject } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(50);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const questionList = await GetQuestionsBySubject(subject, pageNumber, pageSize);
      //const jsonQuestionList = JSON.parse(questionList);

      const jsonQuestionList = JSON.parse(questionList);
      setQuestions(jsonQuestionList.question || []);
      //console.log("API Response:", jsonQuestionList);
      //console.log("Is Array?", Array.isArray(jsonQuestionList));
      //setQuestions(jsonQuestionList);
    } catch (error) {
      console.error('Error fetching interview questions:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (subject) {
      fetchQuestions();
    }
  }, [subject, pageNumber]);

  return (
    <div>
      <Helmet>
        <title>{`${subject} - Interview Questions and Answers - Data Beautifier`}</title>
        <meta name="description" content={`Prepare for your ${subject} interviews with our comprehensive collection of interview questions and answers.`} />
        <link rel="canonical" href={`https://databeautifier.com/questions-answers/${subject}`} />
        <meta property="og:title" content={`${subject} Interview Questions - Data Beautifier`} />
        <meta property="og:url" content={`https://databeautifier.com/questions-answers/${subject}`} />
      </Helmet>

      <Header />

      <div className="page-title-area">
        <div className="container">
          <div className="page-title-content">
            <h2>{subject} Interview Questions</h2>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/interviewlist">Interview</a></li>
              <li className="active">{subject}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="interview-area ptb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              {loading ? (
                <Loader />
              ) : questions?.length === 0 ? (
                <div className="text-center">
                  <p>No interview questions available for this subject yet.</p>
                </div>
              ) : (
                <div className="questions-list">
                  {questions?.map((question, index) => (
                    <InterviewQuestionItem 
                      key={question.id} 
                      question={question} 
                      index={index + 1}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InterviewQuestionsAnswers;